import companySizeByPrice from './companySizeByPrice'

const plans = {
  companySizeByPrice,
}

export default plans
